import { render, staticRenderFns } from "./ASocialButton.vue?vue&type=template&id=13846578&"
import script from "./ASocialButton.vue?vue&type=script&lang=js&"
export * from "./ASocialButton.vue?vue&type=script&lang=js&"
import style0 from "./ASocialButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports